import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable()
export class AirtableService {
    constructor(private apiService: ApiService) {}

    getTable() {
        return this.apiService.getCall$<AirtableArea[]>(`airtable`);
    }

    getGemeenten() {
        return this.apiService.getCall$<GeoJsonFeatureCollection>(`airtable/gemeenten`);
    }

    getProvincies() {
        return this.apiService.getCall$<GeoJsonFeatureCollection>(`airtable/provincies`);
    }

    getWaterschappen() {
        return this.apiService.getCall$<GeoJsonFeatureCollection>(`airtable/waterschappen`);
    }
}

export type AreaType = 'gemeente' | 'provincie' | 'waterschap' | 'unknown';

export interface AirtableArea {
    name: string | null;
    title: string | null;

    areaCode: string;
    geoJsonKey: string;
    areaType: AreaType;

    status: string | null;

    roadLengthKm: number | null;
    distanceFromUtrechtKm: number | null;

    remarks: string | null;
    contracts: AirtableContract[];
}

export interface AirtableContract {
    id: string | null;
    status: string | null;
    description: string | null;
    typeOfTender: string | null;
    typeOfContract: string | null;
    contractValue?: number | null;
    monthsUntilTender?: number | null;
}

export interface GeoJsonFeatureCollection {
    type?: string;
    name?: string;
    features: GeoJsonFeature[];
}

export type GeoJsonPosition = [number, number];

export interface GeoJsonFeature {
    properties: GeoJsonProperties;
    geometry: GeoJsonGeometry;
}

export type GeoJsonGeometry =
    | {
          type: 'Polygon';
          coordinates: GeoJsonPosition[][];
      }
    | {
          type: 'MultiPolygon';
          coordinates: GeoJsonPosition[][][];
      }
    | {
          type?: string;
          coordinates: unknown;
      };

export type PolygonCoordinates = [number, number][][];
export type MultiPolygonCoordinates = [number, number][][][];

export interface GeoJsonProperties {
    // Gemeenten
    GM_CODE?: string;
    GM_NAAM?: string;
    H2O?: string;

    // Provincies / waterschappen
    statcode?: string;
    statnaam?: string;
    name?: string;
    PROV_NAAM?: string;
    waterschap?: string;

    [key: string]: unknown;
}
